var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSodarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54987 1.53852V0.769287H5.38477V1.53852H9.54987ZM10.0705 2.37805V3.14728H5.38477V2.37805H10.0705ZM11.1118 4.75607V3.98684H5.38477V4.75607H11.1118ZM12.1531 5.5956V6.36483H5.38477V5.5956H12.1531ZM12.6737 7.97361V7.20438H5.38477V7.97361H12.6737ZM13.5211 8.81315V9.58238H5.38477V8.81315H13.5211ZM5.39945 10.3292H14.4911C14.4911 10.3292 15.3317 14.9018 10.4932 16.0765C10.4702 16.0821 10.4683 16.184 10.4654 16.3466C10.4561 16.854 10.4362 17.9529 9.73016 18.5676C8.58383 19.5656 6.30477 19.6082 5.39945 17.4967C5.37008 17.4282 5.39945 10.3292 5.39945 10.3292Z",
    fill: "#1E2447"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodarIcon);
export default __webpack_public_path__ + "static/media/SodarIcon.0ab9e1bf.svg";
export { ForwardRef as ReactComponent };